document
  .getElementById("brand-collection")
  .addEventListener("change", function () {
    if (this.value) {
      window.location.href = "/collections/" + this.value;
    }
  });

document.addEventListener("DOMContentLoaded", function () {
  const typeSelect = document.getElementById("product-type");
  const accordionBlocks = document.querySelectorAll(".accordion-subitem");

  // Run once on load
  filterByType(typeSelect.value);

  // Re-run whenever selection changes
  typeSelect.addEventListener("change", function () {
    filterByType(this.value);
  });

  function filterByType(selectedType) {
    accordionBlocks.forEach((block) => {
      const blockType = block.getAttribute("data-type");
      if (selectedType === "" || selectedType === blockType) {
        block.style.display = "";
      } else {
        block.style.display = "none";
      }
    });
  }
});
